export default __webpack_public_path__ + "static/media/completed_projects.ec9696fa.svg";